import React from "react";
import { BlogType } from "../../../Types/types";
import Blog from "./Blog";

interface BlogListProps {
  blogs: BlogType[];
}

const BlogList = ({
  blogs,
}: BlogListProps) => {
  return (
    <div className="bg-[#e6e0ff] p-4 sm:p-8 rounded-3xl">
      <h2 className="text-4xl sm:text-5xl font-bold montserrat-semibold mb-9">
        Discover Fresh Topics in Our Blog
      </h2>
      <div className="grid grid-cols-1 gap-4 mb-2 xl:grid-cols-2 sm:mb-4">
        {blogs.map((blog) => (
          <Blog
            key={blog.slug}
            blog={blog}
          />
        ))}
      </div>
    </div>
  );
};

export default BlogList;
